export const INSPIRED_BY_LOGO_STYLE_LIST = [
    {
        title: 'cartoon',
        link: '/logo-maker/ideas/style/cartoon',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e48c8e0efdffeb76e453d278c71dbcf6-1618925142917/cartoon.png',
    },
    {
        title: 'minimalist',
        link: '/logo-maker/ideas/style/minimalist',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e48c8e0efdffeb76e453d278c71dbcf6-1618925142940/minimalist.png',
    },
    {
        title: 'geometric',
        link: '/logo-maker/ideas/style/geometric',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e48c8e0efdffeb76e453d278c71dbcf6-1618925142924/gometric.png',
    },
    {
        title: 'handdrawn',
        link: '/logo-maker/ideas/tag/drawing',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e48c8e0efdffeb76e453d278c71dbcf6-1618925142942/handdrawn.png',
    },
    {
        title: 'three_d',
        link: '/logo-maker/ideas/style/3d',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e48c8e0efdffeb76e453d278c71dbcf6-1618925142921/3d.png',
    },
    {
        title: 'vintage',
        link: '/logo-maker/ideas/style/vintage',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e48c8e0efdffeb76e453d278c71dbcf6-1618925142931/vintage.png',
    },
];

export const INSPIRED_BY_LOGO_TYPE_LIST = [
    {
        title: 'emblem',
        link: '/logo-maker/ideas/symbol-type/emblem',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e48c8e0efdffeb76e453d278c71dbcf6-1618925142925/emblem.png',
    },
    {
        title: 'monograms',
        link: '/logo-maker/ideas/monograms',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e48c8e0efdffeb76e453d278c71dbcf6-1618925142933/monogram.png',
    },
    {
        title: 'pictorial',
        link: '/logo-maker/ideas/symbol-type/pictorial',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e48c8e0efdffeb76e453d278c71dbcf6-1618925142939/pictorial.png',
    },
    {
        title: 'mascot',
        link: '/logo-maker/ideas/symbol-type/mascot',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e48c8e0efdffeb76e453d278c71dbcf6-1618925142939/mascot.png',
    },
    {
        title: 'abstract',
        link: '/logo-maker/ideas/symbol-type/abstract',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e48c8e0efdffeb76e453d278c71dbcf6-1618925142917/abstract.png',
    },
];

export const INSPIRED_BY_LOGO_BRAND_LIST = [
    {
        title: 'serious',
        link: '/logo-maker/ideas/brand-values/serious',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e48c8e0efdffeb76e453d278c71dbcf6-1618925142942/serious.png',
    },
    {
        title: 'modern',
        link: '/logo-maker/ideas/brand-values/modern',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e48c8e0efdffeb76e453d278c71dbcf6-1618925142930/modern.png',
    },
    {
        title: 'established',
        link: '/logo-maker/ideas/brand-values/established',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e48c8e0efdffeb76e453d278c71dbcf6-1618925142928/established.png',
    },
    {
        title: 'sophisticated',
        link: '/logo-maker/ideas/brand-values/sophisticated',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e48c8e0efdffeb76e453d278c71dbcf6-1618925142929/sophisticated.png',
    },
    {
        title: 'innovative',
        link: '/logo-maker/ideas/brand-values/innovative',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e48c8e0efdffeb76e453d278c71dbcf6-1618925142942/innovative.png',
    },
    {
        title: 'classic',
        link: '/logo-maker/ideas/brand-values/classic',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/e48c8e0efdffeb76e453d278c71dbcf6-1618925142920/classic.png',
    },
    {
        title: 'luxurious',
        link: '/logo-maker/ideas/tag/luxury',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/3dc1c8b282e16bd56b933ab4cdd07c3c-1618927849816/luxurious.png',
    },
];
